import React from 'react';

import { SPACE_OVERVIEW } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { getSpaceOverviewRoute } from '@confluence/ssr-app/entry-points/routes.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';

/**
 * Keeping the redirection because refined themes only support space overview route.
 * https://atlassian.slack.com/archives/CFGSEJDFT/p1721136254384829
 */
export const SpaceIndexRoute: {
	(match: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { spaceKey }, query: { mode } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					isGlobalMode: boolean;
					navdexPointType: string;
					spaceKey: string;
				};
			};
			pageState: {
				spaceKey: string;
				contentId: any;
				routeName: string;
				contentType: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
			isViewPage: boolean;
		};
	};
} = getSpaceOverviewRoute(({ spaceKey, query }) => (
	<Redirection name={SPACE_OVERVIEW.name} params={{ spaceKey, query }} />
));
